var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileprofessionalsinterested(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z",
    fill: "#E4E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 41.25V38.75C18.75 37.4239 19.2768 36.1521 20.2145 35.2145C21.1521 34.2768 22.4239 33.75 23.75 33.75H28.75C30.0761 33.75 31.3479 34.2768 32.2855 35.2145C33.2232 36.1521 33.75 37.4239 33.75 38.75V41.25M35 18.9125C36.0755 19.1879 37.0288 19.8134 37.7095 20.6904C38.3903 21.5674 38.7598 22.646 38.7598 23.7563C38.7598 24.8665 38.3903 25.9451 37.7095 26.8221C37.0288 27.6991 36.0755 28.3246 35 28.6M41.25 41.25V38.75C41.2437 37.6464 40.8724 36.576 40.1941 35.7055C39.5158 34.835 38.5685 34.2134 37.5 33.9375M21.25 23.75C21.25 25.0761 21.7768 26.3479 22.7145 27.2855C23.6521 28.2232 24.9239 28.75 26.25 28.75C27.5761 28.75 28.8479 28.2232 29.7855 27.2855C30.7232 26.3479 31.25 25.0761 31.25 23.75C31.25 22.4239 30.7232 21.1521 29.7855 20.2145C28.8479 19.2768 27.5761 18.75 26.25 18.75C24.9239 18.75 23.6521 19.2768 22.7145 20.2145C21.7768 21.1521 21.25 22.4239 21.25 23.75Z",
    stroke: "#6B7280",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileprofessionalsinterested);
export default __webpack_public_path__ + "static/media/profile professionals interested.4ab6de4b3dc2457c62639b220462f76d.svg";
export { ForwardRef as ReactComponent };